import { Map } from 'immutable';
import { COMPANY } from '@constants/actions';

const initialState = Map({
  company: {},
  retrieveInProgress: true,
  people: {
    source: '',
    officers: []
  },
  companiesByIds: []
});

const Company = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case COMPANY.COMPANY_DETAIL:
      return state.set('company', actionPayload.response.data);
    case COMPANY.RETRIEVE_IN_PROGRESS:
      return state.set('retrieveInProgress', action.payload.progress);
    case COMPANY.COMPANY_PEOPLE:
      return state.set('people', actionPayload.response.data);
    
    case COMPANY.COMPANY_RETRIEVE_BY_IDS:
      return state.set('companiesByIds', actionPayload?.response?.data)
    
    default:
      return state;
  }
};

export default Company;
